import {
  Card,
  CardContent,
  Box,
  Typography,
  Chip,
  Paper,
  Grid,
  LinearProgress,
} from "@mui/material";
import { Analytics } from "@mui/icons-material";

const UserActivityCard = ({
  activeUsers,
  nonAdminUserCount,
  activityStatus,
}) => {
  return (
    <Card elevation={2}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Analytics color="primary" sx={{ mr: 1 }} />
          <Typography variant="h6" fontWeight="bold">
            User Activity
          </Typography>
          <Chip
            label={activityStatus.label}
            color={activityStatus.color}
            size="small"
            sx={{ ml: "auto" }}
          />
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Paper
              elevation={0}
              sx={{
                p: 2,
                bgcolor: "success.light",
                color: "white",
                textAlign: "center",
                textShadow: "0 1px 2px rgba(0, 0, 0, 0.9)",
              }}
            >
              <Typography
                variant="h5"
                fontWeight="bold"
                sx={{
                  color: "white !important",
                  textShadow: "0 1px 2px rgba(0, 0, 0, 0.9)",
                }}
              >
                {activeUsers}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  color: "white !important",
                  textShadow: "0 1px 2px rgba(0, 0, 0, 0.9)",
                }}
              >
                Active Users
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "white !important",
                  textShadow: "0 1px 2px rgba(0, 0, 0, 0.9)",
                }}
              >
                Last 7 days
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={6}>
            <Paper
              elevation={0}
              sx={{
                p: 2,
                bgcolor: "primary.light",
                color: "white",
                textAlign: "center",
                textShadow: "0 1px 2px rgba(0, 0, 0, 0.9)",
              }}
            >
              <Typography
                variant="h5"
                fontWeight="bold"
                sx={{
                  color: "white !important",
                  textShadow: "0 1px 2px rgba(0, 0, 0, 0.9)",
                }}
              >
                {nonAdminUserCount - activeUsers}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  color: "white !important",
                  textShadow: "0 1px 2px rgba(0, 0, 0, 0.9)",
                }}
              >
                Inactive Users
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "white !important",
                  textShadow: "0 1px 2px rgba(0, 0, 0, 0.9)",
                }}
              >
                7+ days ago
              </Typography>
            </Paper>
          </Grid>
        </Grid>
        <Box sx={{ mt: 2 }}>
          <LinearProgress
            variant="determinate"
            value={
              nonAdminUserCount > 0
                ? (activeUsers / nonAdminUserCount) * 100
                : 0
            }
            color="success"
            sx={{ height: 8, borderRadius: 4 }}
          />
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ mt: 1, display: "block" }}
          >
            {nonAdminUserCount > 0
              ? Math.round((activeUsers / nonAdminUserCount) * 100)
              : 0}
            % of users active in last week
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default UserActivityCard;
